module.exports = "pegasus_template/assets/themelp1/travel/111.png";